/* Timezone — время показываем в ВЫБРАННОЙ зоне, ровно как строятся фильтры по дате */
import { inTz, nowInTz } from "../../helpers/timezone"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"


/* HOW MANY FACES THE PANEL HAS — /images/player/gamer1..gamer11 */
const AVATARS = 11


/* NUMBER OF THE FACE — THE SAME CODE ALWAYS GETS THE SAME ONE
 * The picture is not stored anywhere, so it is taken from the code of the player instead of a random
 * number: otherwise every row of the same player would draw a different face on every render. */
export const getAvaIndex = (item) => {

    /* Fields */
    const code = String(item.player ? item.player : "")
    let hash = 0

    /* Hash Of The Code */
    for (let index = 0; index < code.length; index++) {
        hash = (hash * 31 + code.charCodeAt(index)) % AVATARS
    }

    /* Send Result */
    return hash
}


/* AVATAR OF A PLAYER */
export const getAvatar = (item) => {

    /* Check Tester — a test account has a face of its own */
    if (parseInt(item.isTester) === 1) {
        return utils.ava(0, "test")
    }

    /* Send Result */
    return utils.ava(getAvaIndex(item), "")
}


/* NAME OF A GAME — A TABLE MAY ALREADY BE DELETED, THEN THE SLUG IS ALL WE HAVE */
export const getGame = (item) => {

    /* Check Name */
    if (item.game) {
        return item.game
    }

    /* Check Slug */
    if (item.table) {
        return item.table
    }

    /* Send Result */
    return t("msg.noGame")
}


/* NAME OF THE PLAYER — THE MESSAGE KEEPS ITS OWN COPY, Users KEEPS THE CURRENT ONE */
export const getName = (item) => {

    /* Check Name */
    if (item.firstName) {
        return item.firstName
    }

    /* Check Player */
    if (item.playerName) {
        return item.playerName
    }

    /* Send Result */
    return "—"
}


/* PLAIN NUMBER OF THE STATS — A COUNTER IS WHOLE, IT KEEPS NO CENTS */
export const formatCount = (value) => {

    /* Fields */
    const number = parseInt(value)

    /* Check Value */
    if (isNaN(number)) {
        return "0"
    }

    /* Send Result */
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}


/* DAY OF A MESSAGE */
export const formatDay = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY")
}


/* TIME OF A MESSAGE */
export const formatTime = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("HH:mm:ss")
}


/* HOW LONG AGO IT HAPPENED
 * The units are abbreviations on purpose — they need no plural agreement in any language,
 * and anything older than two months is shown as a plain date instead. */
export const formatAgo = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Fields */
    const minutes = nowInTz().diff(inTz(value), "minutes")

    /* Check Future — the clock of a game server may run ahead of the panel */
    if (minutes < 1) {
        return t("log.ago.now")
    }

    /* Minutes */
    if (minutes < 60) {
        return `${minutes} ${t("log.ago.minutes")} ${t("log.ago.suffix")}`
    }

    /* Hours */
    if (minutes < 60 * 24) {
        return `${Math.floor(minutes / 60)} ${t("log.ago.hours")} ${t("log.ago.suffix")}`
    }

    /* Days */
    if (minutes < 60 * 24 * 60) {
        return `${Math.floor(minutes / (60 * 24))} ${t("log.ago.days")} ${t("log.ago.suffix")}`
    }

    /* Send Result */
    return formatDay(value)
}
